import { createSlice } from "@reduxjs/toolkit";
import { VoiceState } from "../store/types";

const initialState: VoiceState = {
  requested: false,
};

/**
 * Only records *whether* the user wants voice mode. The session itself (state
 * machine, microphone, playback) lives in VoiceModeHost, which is mounted once
 * at app level.
 *
 * Keeping it out of the store is deliberate: the session updates on every audio
 * level sample, which would otherwise re-render every connected component
 * twenty times a second. Keeping the *request* in the store is equally
 * deliberate - the microphone button lives inside SearchField, which unmounts
 * when a question is asked from the circle view, and a session anchored there
 * would die mid-answer.
 */
const voiceSlice = createSlice({
  name: "voice",
  initialState,
  reducers: {
    requestVoiceMode(state) {
      state.requested = true;
    },
    exitVoiceMode(state) {
      state.requested = false;
    },
  },
});

export default voiceSlice.reducer;
export const voiceActions = voiceSlice.actions;
